var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 10,
    fill: "#222120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0503 19.4705C43.1985 22.9964 36.1659 24.8775 30.1111 24.8775C21.6212 24.8775 13.9781 21.7817 8.19584 16.6327C7.74154 16.2278 8.14859 15.676 8.69375 15.9913C14.934 19.5709 22.6497 21.7244 30.6199 21.7244C35.9951 21.7244 41.9082 20.6279 47.3453 18.3526C48.1666 18.0086 48.8535 18.8829 48.0503 19.4705Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8201 17.162C49.2189 16.3793 45.8312 16.7922 44.3106 16.9753C43.8474 17.0328 43.7766 16.6235 44.1939 16.3291C46.8921 14.401 51.3194 14.9575 51.8357 15.6038C52.352 16.2537 51.7014 20.7596 49.1659 22.9103C48.7769 23.2406 48.4056 23.0647 48.5788 22.6267C49.1482 21.1833 50.4248 17.9483 49.8201 17.162Z",
    fill: "#FF9900"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonIcon);
export default __webpack_public_path__ + "static/media/AmazonIcon.df2af9407cc74260f38a9ae6c04cc03e.svg";
export { ForwardRef as ReactComponent };